import { IS_SIDE_MODE_KEY } from '@portals/help-center-core/lib/_internal';
import { ReadonlyURLSearchParams } from 'next/dist/client/components/navigation.react-server';
import {
  EGoBackOption,
  GO_BACK_OPTION,
  MATERIAL_CATEGORY_ID,
  TSearchParams,
} from '@/_types/route-params';

export const getSearchParamsFromUrlString = (
  searchParamsUrl: ReadonlyURLSearchParams,
): TSearchParams => {
  const params: TSearchParams = {};

  if (searchParamsUrl.get(IS_SIDE_MODE_KEY) === 'true') {
    params[IS_SIDE_MODE_KEY] = 'true';
  }

  const goBackOption = searchParamsUrl.get(GO_BACK_OPTION) as
    EGoBackOption | '';

  if (goBackOption) {
    params[GO_BACK_OPTION] = goBackOption;
  }

  const materialCategoryId = searchParamsUrl.get(MATERIAL_CATEGORY_ID);
  if (materialCategoryId) {
    params[MATERIAL_CATEGORY_ID] = materialCategoryId;
  }

  return params;
};
